import type { CloudGraphDashboardEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI: CloudGraphDashboardEntityAti[] = [
	'ati:cloud:graph:dashboard',
];
